import React, { useEffect, useState } from "react";
import { useRefreshTick } from "@/lib/autoRefresh";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { formatRupiah, formatDate } from "@/lib/format";
import { CheckSquare, ArrowRight, Inbox } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function Approvals() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const tick = useRefreshTick();

  useEffect(() => {
    api.get("/cash-requests", { params: { status: "pending" } }).then((r) => setRows(r.data)).catch(() => {});
  }, [tick]);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold flex items-center gap-2" style={{ fontFamily: "Outfit" }}>
          <CheckSquare className="h-6 w-6 text-brand" /> Antrian Approval
        </h2>
        <p className="text-sm text-muted-foreground">Pengajuan kas yang menunggu keputusan Anda.</p>
      </div>

      {rows.length === 0 ? (
        <Card className="p-12 flex flex-col items-center justify-center text-center">
          <Inbox className="h-10 w-10 text-muted-foreground mb-3" />
          <p className="font-medium">Antrian kosong</p>
          <p className="text-sm text-muted-foreground">Tidak ada pengajuan yang menunggu approval saat ini.</p>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {rows.map((r) => (
            <Card key={r.id} className="p-5 hover:shadow-md transition-shadow" data-testid={`approval-card-${r.id}`}>
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="font-semibold truncate">{r.requester_name}</p>
                  <p className="text-xs text-muted-foreground">{r.divisi} · {formatDate(r.created_at)}</p>
                </div>
                <span className="text-lg font-bold font-mono text-brand shrink-0">{formatRupiah(r.amount_requested)}</span>
              </div>
              <p className="text-sm text-muted-foreground mt-3 line-clamp-2">{r.reason}</p>
              <Button onClick={() => navigate(`/requests/${r.id}`)}
                className="w-full mt-4 bg-brand hover:bg-emerald-800" data-testid={`review-btn-${r.id}`}>
                Review & Proses <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
